module.exports = __webpack_public_path__ + "static/media/logo.636ad8d5.png";